import { MessageCircle } from "lucide-react";
import * as React from "react";

// Define the props type for clarity
interface ThreadReplyCountProps {
  reviewId: number;
  review: any; // Consider defining a more specific type for review if possible
}

export function ThreadReplyCount({ reviewId, review }: ThreadReplyCountProps) {
  // Calculate count directly if threadMessages is available, otherwise use threadMessageCount
  const count = review.threadMessages
    ? review.threadMessages.length
    : (review.threadMessageCount ?? 0);

  return (
    <span
      className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-mono font-medium bg-muted text-muted-foreground transition-colors hover:bg-muted/80 dark:bg-muted/50 dark:hover:bg-muted/70 cursor-pointer"
      data-review-id={reviewId}
    >
      <MessageCircle className="h-3 w-3" />
      <span>{count}</span>
    </span>
  );
}
